import { useLang } from '@/i18n';
import css from './index.module.scss';
import Icon1 from './icons/Icon1';
import Icon2 from './icons/Icon2';
import Icon3 from './icons/Icon3';
import Icon4 from './icons/Icon4';
import Icon5 from './icons/Icon5';
import EcoImg from 'eco-design/base/eco-img';

interface ItfItem {
    title: string;
    desc: string;
    icon: React.FC;
}
const Tab2: React.FC = () => {
    const { t } = useLang('stream.overview');
    const items: ItfItem[] = [
        {
            title: t('E_item2_list1_title'),
            desc: t('E_item2_list1_desc'),
            icon: Icon1,
        },
        {
            title: t('E_item2_list2_title'),
            desc: t('E_item2_list2_desc'),
            icon: Icon2,
        },
        {
            title: t('E_item2_list3_title'),
            desc: t('E_item2_list3_desc'),
            icon: Icon3,
        },
        {
            title: t('E_item2_list4_title'),
            desc: t('E_item2_list4_desc'),
            icon: Icon4,
        },
        {
            title: t('E_item2_list5_title'),
            desc: t('E_item2_list5_desc'),
            icon: Icon5,
        },
    ];
    return (
        <div className={`${css.frag}`}>
            <EcoImg
                className="tab2-img"
                pc="https://websiteoss.ecoflow.com/upload/image/1774594568668/e2.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1774594568668/e2.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1774594568849/e2m.jpg"
                alt={t('E_item2_list1_title')}
            />
            <ul className="items">
                {items?.map((item: ItfItem) => (
                    <li className="item" key={item.title}>
                        <item.icon />
                        <p className="item-title">{item.title}</p>
                        <p className="item-desc">{item.desc}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Tab2;
